import {Injectable} from '@angular/core';

@Injectable()
export class DataStorageService {

  private sharedData: any;
  private incrementInd: {ind: number; ts: number};

  setIncrement(increment: any){
    this.incrementInd = increment;
  }

  getIncrement(): any{
    return this.incrementInd;
  }

  setData(data: any) {
    this.sharedData = data;
  }

  getData() {
    return this.sharedData;
  }

}
